module.exports = __webpack_public_path__ + "img/pdf-file.953dab7b.svg";